import { z } from 'zod';

import { positionPlanErrorSchema } from '../../position-management';

export const POSITION_PLAN_TOOL_ID = 'manage_position_plan';

const positionPlanProgressApplySchema = z.object({
    chunksDone: z.number().int().nullish(),
    chunksTotal: z.number().int().nullish(),
    seatsCreated: z.number().int().nullish(),
});

const positionPlanProgressRunSchema = z.object({
    stage: z.string().nullish(),
    unitsDone: z.number().int().nullish(),
    unitsTotal: z.number().int().nullish(),
});

/**
 * The state of one position plan when the agent emitted it. Every emission for a plan carries the
 * same `blockId`, and nothing updates the block once the turn ends, so the card reads the plan by
 * `planId` for its current state. The status stays a string: a status this client does not know
 * must not drop the card.
 */
export const positionPlanProgressBlockSchema = z.object({
    type: z.literal('position-plan-progress'),
    blockId: z.string(),
    architectureId: z.string(),
    planId: z.string(),
    status: z.string().nullish(),
    run: positionPlanProgressRunSchema.nullish(),
    apply: positionPlanProgressApplySchema.nullish(),
    error: positionPlanErrorSchema.nullish(),
});

export type PositionPlanProgressBlock = z.infer<typeof positionPlanProgressBlockSchema>;
